// Fake component controller so this code is autoloaded
//
import { Controller } from 'stimulus'

const VARIABLE_TO_FORWARD = '--previous-node-divider-height'

export default class extends Controller {
  connect() {
    this.forwardVariableToFirstVisibleSection()
  }

  disconnect() {
    this.#cleanupForward()
  }

  forwardVariableToFirstVisibleSection() {
    this.#cleanupForward()

    if (!this.#shouldForward()) return

    const nextSibling = this.#nextSibling

    const value =
      getComputedStyle(nextSibling).getPropertyValue(VARIABLE_TO_FORWARD)

    const nextVisibleSibling = this.#getNextVisibleSibling(nextSibling)
    if (value && nextVisibleSibling) {
      nextVisibleSibling.style.setProperty(VARIABLE_TO_FORWARD, value)
      this.forwardedToElement = nextVisibleSibling
    }
  }

  #cleanupForward() {
    this.forwardedToElement?.style?.setProperty(VARIABLE_TO_FORWARD, null)
    this.forwardedToElement = null
  }

  #shouldForward() {
    return this.#nextSibling && !this.#isVisible(this.#nextSibling)
  }

  #getNextVisibleSibling(element) {
    let nextSibling = element.nextElementSibling
    if (!nextSibling) return null
    if (this.#isVisible(nextSibling)) return nextSibling
    return this.#getNextVisibleSibling(nextSibling)
  }

  #isVisible(element) {
    return getComputedStyle(element).display !== 'none'
  }

  get #nextSibling() {
    return this.element.nextElementSibling
  }
}
